import { getUrl } from 'helpers';
import { useMemo } from 'react';

export default function Image({ alt, height, maxHeight, maxWidth, src, width }: ImageProps) {
    const imgSrc = useMemo(() => {
        return src ? getUrl(src) : undefined;
    }, [src]);

    const imgStyle = useMemo(() => {
        return {
            height,
            maxHeight,
            maxWidth: maxWidth || '100%',
            width: width || '100%',
        };
    }, [height, maxHeight, maxWidth, width]);

    return (
        <picture>
            <img alt={alt ?? ''} src={imgSrc} style={imgStyle} />
        </picture>
    );
}
